export const JSM_HELP_EXTENSION_TYPE = 'com.atlassian.hub.jsm-help';
export const JSM_HELP_EXTENSION_KEY = 'jsm-help';

export const JSM_HELP_EXTENSION_ANALYTIC_SOURCE = 'jsmHelpExtension';
export const JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'jsmHelpExtensionConfig';

export const JSM_HELP_EXTENSION_VERSION_1 = '1.0.0';
export const PAGE_SIZE = 9;

export const CardSize = {
	SMALL: 'small',
	LARGE: 'large',
} as const;

export type CardSize = (typeof CardSize)[keyof typeof CardSize];

export const SourceType = {
	MANUAL: 'manual',
	COMMON_REQUESTS: 'common-requests',
	PORTAL_CARDS: 'portal-cards',
} as const;

export type SourceType = (typeof SourceType)[keyof typeof SourceType];
